import React from 'react';
import { Stack, Typography, Button, BookOpen02Icon } from '@metarouter-private/mr-mui';

export default function Documentation() {
  return (
    <Stack spacing={2} alignItems="flex-start">
      <Typography variant="h6">Webhooks</Typography>
      <Typography variant="body2">
        Webhooks send real-time HTTP notifications to your server when events occur in MetaRouter, such as config
        changes or file deployments.
      </Typography>
      <Typography variant="body2">
        Each organization can have one webhook endpoint. When creating a webhook, you will receive an HMAC signing
        secret that can be used to verify the authenticity of incoming requests.
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<BookOpen02Icon />}
        href="https://docs.metarouter.io/docs/deploying-your-ajs-tracking-file#step-3-optional--configure-your-deployment-webhook"
        target="_blank"
        rel="noreferrer noopener"
      >
        Documentation
      </Button>
    </Stack>
  );
}
